// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MapPOIS_wrapper__2TYOE","map_title_style":"MapPOIS_map_title_style__37WGR"};